// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTextCursorInput as RawLucideTextCursorInput } from "lucide-react";
export const LucideTextCursorInput = /* @__PURE__ */ createIcon(RawLucideTextCursorInput, "LucideTextCursorInput", 2);
